import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container py-4" }
const _hoisted_2 = { class: "mb-4 text-primary" }
const _hoisted_3 = { class: "d-flex gap-2 mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_5 = {
  key: 1,
  class: "text-muted text-center py-3"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_7 = {
  key: 1,
  class: "text-muted text-center py-3"
}

import { ref, computed, provide, onMounted } from "vue";
  import axios from "axios";
  import { BTabs, BTab } from "bootstrap-vue-next";
  import OpeningHoursBlock from "./OpeningHoursBlock.vue";
  import WeekdayOpeningHours from "./WeekdayOpeningHours.vue";
  import SpecificDateOpeningHours from "./SpecificDateOpeningHours.vue";

  
export default {
  __name: 'OpeningHours',
  props: {
    buildingName: { type: String, required: true },
    buildingId: { type: Number, required: true },
    fetchUrl: { type: String, required: true },
    deleteUrl: { type: String, required: false, default: "" },
    saveUrl: { type: String, required: true },
  },
  setup(__props) {

  const props = __props;

  const activeTab = ref(0);

  const openingHours = ref({
    current: [],
    future: [],
    specialDates: [],
  });

  const permissions = ref({
    canCreate: false,
    canEdit: false,
    canDelete: false,
  });

  // Provide permissions as computed property
  provide(
    "permissions",
    computed(() => permissions.value)
  );
  provide("deleteUrl", props.deleteUrl);
  provide("saveUrl", props.saveUrl);

  const updateUrlParam = (tabIndex) => {
    const url = new URL(window.location);
    url.searchParams.set("tab", tabIndex);
    window.history.replaceState({}, "", url);
  };

  const handleTabChange = (tabIndex) => {
    activeTab.value = tabIndex;
    updateUrlParam(tabIndex);
  };

  onMounted(() => {
    const url = new URL(window.location);
    const tabParam = url.searchParams.get("tab");
    if (tabParam !== null) {
      activeTab.value = parseInt(tabParam, 10);
    }
  });

  const fetchOpeningHours = async () => {
    try {
      const { data } = await axios.get(props.fetchUrl);
      openingHours.value = data.openingHours;
      permissions.value = data.permissions;
    } catch (error) {
      console.error("Failed to fetch opening hours:", error);
    }
  };

  // Call fetch on component creation
  fetchOpeningHours();

return (_ctx, _cache) => {
  const _component_b_button = _resolveComponent("b-button")
  const _directive_b_modal = _resolveDirective("b-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.buildingName) + " " + _toDisplayString(" ") + " Öffnungszeiten ", 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createBlock(_component_b_button, {
        size: "sm",
        variant: "primary"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Wochenzeiten erstellen ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      })), [
        [
          _directive_b_modal,
          void 0,
          void 0,
          { weekdayOpeningHoursModal: true }
        ]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_b_button, {
        size: "sm",
        variant: "primary"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Datum erstellen ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      })), [
        [
          _directive_b_modal,
          void 0,
          void 0,
          { specificDateOpeningHoursModal: true }
        ]
      ])
    ]),
    _createVNode(SpecificDateOpeningHours, {
      "save-url": __props.saveUrl,
      "modal-id": "specificDateOpeningHoursModal"
    }, null, 8 /* PROPS */, ["save-url"]),
    _createVNode(WeekdayOpeningHours, {
      "save-url": __props.saveUrl,
      "modal-id": "weekdayOpeningHoursModal"
    }, null, 8 /* PROPS */, ["save-url"]),
    _createVNode(_unref(BTabs), {
      modelValue: activeTab.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = $event => ((activeTab).value = $event)),
        handleTabChange
      ],
      "content-class": "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BTab), { title: "Aktuelle Konfiguration" }, {
          default: _withCtx(() => [
            (openingHours.value.current.length || openingHours.value.specialDates.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (openingHours.value.current.length)
                    ? (_openBlock(), _createBlock(OpeningHoursBlock, {
                        key: 0,
                        "modal-id": "currentWeekdayOpeningHoursModal",
                        entries: openingHours.value.current
                      }, null, 8 /* PROPS */, ["entries"]))
                    : _createCommentVNode("v-if", true),
                  (openingHours.value.specialDates.length)
                    ? (_openBlock(), _createBlock(OpeningHoursBlock, {
                        key: 1,
                        entries: openingHours.value.specialDates
                      }, null, 8 /* PROPS */, ["entries"]))
                    : _createCommentVNode("v-if", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, " Keine aktuellen Öffnungszeiten vorhanden. "))
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_unref(BTab), { title: "Zukünftige Konfigurationen" }, {
          default: _withCtx(() => [
            (Object.keys(openingHours.value.future).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(openingHours.value.future), ([date, entries]) => {
                    return (_openBlock(), _createBlock(OpeningHoursBlock, {
                      key: date,
                      "modal-id": `futureWeekdayOpeningHoursModal-${date}`,
                      entries: entries
                    }, null, 8 /* PROPS */, ["modal-id", "entries"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, " Keine zukünftigen Öffnungszeiten konfiguriert. "))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

}